// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const aadhaar: CountryValidator<"IN"> = createValidator(
  "in.aadhaar",
  97,
);

export default aadhaar;
export const compact = aadhaar.compact;
export const format = aadhaar.format;
export const validate = aadhaar.validate;
export const generate = (): string =>
  aadhaar.generate?.() ??
  (() => {
    throw new Error(
      "Validator in.aadhaar cannot generate values",
    );
  })();
